__webpack_require__.p = "https://proposals.microsoft.com/";